import { SearchResults } from "../../Shared/scriptts/interfaces";
import { params, executeSearchUrl, displayResults } from '../search-main';
import { URLCriteriaHelper } from '../search-urlcriteriahelper';

declare var departments: any;
declare var agencies: any;
let showNoCountDepartments = false;
let showNoCountAgencies = false;
let noCountDepartments: HTMLLIElement[] = [];
let noCountAgencies: HTMLLIElement[] = [];
let foundDepartments: HTMLLIElement[] = [];
let foundAgencies: HTMLLIElement[] = [];

const countIcon = document.createElement('span');

/**
 * Display Department and Agency filters
 * @param data The data returned from the search API
 */
export function displayOrganizationFilter(data: SearchResults) {
    buildDepartmentFilter(data);
    buildAgencyFilter(data);
    const count = params.Agency?.length + params.Department?.length;
    const titleElem = document.querySelector<HTMLElement>('#titleaccordion-organization');
    if (titleElem !== null) {
        countIcon.className = count > 0 ? 'bg-warning rounded-full py-1 px-2 ml-2' : 'bg-warning rounded-full py-1 px-2 ml-2 hidden';
        countIcon.innerText = count.toString();
        if (!titleElem.contains(countIcon)) {
            titleElem.appendChild(countIcon);
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelector<HTMLButtonElement>('#filter-org-dept-toggle')?.addEventListener('click', departmentToggleClicked);
    document.querySelector<HTMLButtonElement>('#filter-org-agency-toggle')?.addEventListener('click', agencyToggleClicked);
    document.querySelector<HTMLButtonElement>('#filter-dept-showall-toggle')?.addEventListener('click', showAllDepartmentToggleClicked);
    document.querySelector<HTMLButtonElement>('#filter-agency-showall-toggle')?.addEventListener('click', showAllAgencyToggleClicked);
    document.querySelector<HTMLInputElement>('#dept-search')?.addEventListener('keyup', deptSearchKeyup);
    document.querySelector<HTMLInputElement>('#agency-search')?.addEventListener('keyup', agencySearchKeyup);
});

function buildDepartmentFilter(data: SearchResults, searchText: string = '') {
    const deptContainer = document.querySelector<HTMLUListElement>('#filter-dept-list');
    if (deptContainer === null) {
        return;
    }
    const searchLength = searchText.length;

    deptContainer.innerHTML = '';
    for (let d in departments) {
        let jobCount = !data.f['d'][d] ? "0" : data.f['d'][d].toString();
        const li = document.createElement('li');
        const input = document.createElement('input');
        const label = document.createElement('label');
        const checked = params.Department?.indexOf(d) > -1;

        input.type = "checkbox";
        input.name = "Department";
        input.value = d;
        input.id = `department-id-${d}`;
        input.checked = checked;

        label.setAttribute('for', input.id);
        label.id = `department-label-${d}`;
        label.innerHTML = `${departments[d]?.Name} <span class="text-gray text-sm">(${jobCount})</span>`;

        li.id = `department-li-${d}`;
        li.setAttribute('data-count', jobCount);
        li.appendChild(input);
        li.appendChild(label);

        input.addEventListener('change', departmentChanged);

        if (jobCount === "0" && searchLength < 3) {
            noCountDepartments.push(li);
            
            if (showNoCountDepartments === false && checked === false) {
                li.classList.add('hidden');
            }
        }

        deptContainer.appendChild(li);
    }
}

function buildAgencyFilter(data: SearchResults) {
    const agencyContainer = document.querySelector<HTMLUListElement>('#filter-agency-list');
    if (agencyContainer === null) {
        return;
    }

    agencyContainer.innerHTML = '';
    for (let a in agencies) {
        let jobCount = !data.f['a'][a] ? "0" : data.f['a'][a].toString();
        const li = document.createElement('li');
        const input = document.createElement('input');
        const label = document.createElement('label');

        input.type = "checkbox";
        input.name = "Agency";
        input.value = a;
        input.id = `agency-id-${a}`;
        input.checked = params.Agency?.indexOf(a) > -1;
        input.addEventListener('change', agencyChanged);

        label.setAttribute('for', input.id);
        label.id = `agency-label-${a}`;
        label.innerHTML = `${agencies[a]?.Name} <span class="text-gray text-sm">(${jobCount})</span>`;

        li.id = `agency-li-${a}`;
        li.setAttribute('data-count', jobCount);
        li.appendChild(input);
        li.appendChild(label);

        if (jobCount === "0") {
            noCountAgencies.push(li);

            if (showNoCountAgencies === false) {
                li.classList.add('hidden');
            }
        }

        agencyContainer.appendChild(li);
    }
}

function departmentToggleClicked() {
    document.querySelector<HTMLElement>('#filter-dept')?.classList.remove('hidden');
    document.querySelector<HTMLElement>('#filter-agency')?.classList.add('hidden');
    document.querySelector<HTMLButtonElement>('#filter-org-dept-toggle')?.classList.add('border-b-4');
    document.querySelector<HTMLButtonElement>('#filter-org-agency-toggle')?.classList.remove('border-b-4');
}

function agencyToggleClicked() {
    document.querySelector<HTMLElement>('#filter-dept')?.classList.add('hidden');
    document.querySelector<HTMLElement>('#filter-agency')?.classList.remove('hidden');
    document.querySelector<HTMLButtonElement>('#filter-org-dept-toggle')?.classList.remove('border-b-4');
    document.querySelector<HTMLButtonElement>('#filter-org-agency-toggle')?.classList.add('border-b-4');
}

function departmentChanged(evt: Event) {
    const deptInput = <HTMLInputElement>(evt.target);
    if (params.Department === null) {
        params.Department = [];
    }
    if (deptInput.checked) {
        params.Department.push(deptInput.value);
    }
    else {
        params.Department.splice(params.Department.indexOf(deptInput.value), 1);
    }
    const count = params.Agency?.length + params.Department?.length;
    if (count > 0) {
        countIcon.innerText = count.toString();
        countIcon.classList.remove('hidden');
    }
    else {
        countIcon.innerText = '0';
        countIcon.classList.add('hidden');
    }
    params.Page = '1';
    displayResults(executeSearchUrl, false, true);
    URLCriteriaHelper.reconstructUrl();
}

function agencyChanged(evt: Event) {
    const agencyInput = <HTMLInputElement>(evt.target);
    if (params.Agency === null) {
        params.Agency = [];
    }
    if (agencyInput.checked) {
        params.Agency.push(agencyInput.value);
    }
    else {
        params.Agency.splice(params.Agency.indexOf(agencyInput.value), 1);
    }
    const count = params.Agency?.length + params.Department?.length;
    if (count > 0) {
        countIcon.innerText = count.toString();
        countIcon.classList.remove('hidden');
    }
    else {
        countIcon.innerText = '0';
        countIcon.classList.add('hidden');
    }
    params.Page = '1';
    displayResults(executeSearchUrl, false, true);
    URLCriteriaHelper.reconstructUrl();
}

function setDepartmentFiltersDisplay() {
    const searchLength = document.querySelector<HTMLInputElement>('#dept-search')?.value.length ?? 0;

    document.querySelector<HTMLUListElement>('#filter-dept-list')?.querySelectorAll<HTMLLIElement>('li').forEach(li => {
        const found = foundDepartments.indexOf(li) > -1;
        const inNoCountList = noCountDepartments.indexOf(li) > -1;

        if (li.querySelector<HTMLInputElement>('input')?.checked || (inNoCountList && showNoCountDepartments && (searchLength < 3 || found)) || (!inNoCountList && (searchLength < 3 || found))) {
            li.classList.remove('hidden');
        }
        else {
            li.classList.add('hidden');
        }
    });
}

function setAgencyFiltersDisplay() {
    const searchLength = document.querySelector<HTMLInputElement>('#agency-search')?.value.length ?? 0;

    document.querySelector<HTMLUListElement>('#filter-agency-list')?.querySelectorAll<HTMLLIElement>('li').forEach(li => {
        const found = foundAgencies.indexOf(li) > -1;
        const inNoCountList = noCountAgencies.indexOf(li) > -1;

        if (li.querySelector<HTMLInputElement>('input')?.checked || (inNoCountList && showNoCountAgencies && (searchLength < 3 || found)) || (!inNoCountList && (searchLength < 3 || found))) {
            li.classList.remove('hidden');
        }
        else {
            li.classList.add('hidden');
        }
    });
}

function showAllDepartmentToggleClicked() {
    const toggleButton = document.querySelector<HTMLButtonElement>('#filter-dept-showall-toggle');
    if (toggleButton === null) {
        return;
    }
    showNoCountDepartments = !showNoCountDepartments;
    toggleButton.innerText = showNoCountDepartments ? 'Hide options with 0 jobs' : 'Show options with 0 jobs';
    setDepartmentFiltersDisplay();
}

function showAllAgencyToggleClicked() {
    const toggleButton = document.querySelector<HTMLButtonElement>('#filter-agency-showall-toggle');
    if (toggleButton === null) {
        return;
    }
    showNoCountAgencies = !showNoCountAgencies;
    toggleButton.innerText = showNoCountAgencies ? 'Hide options with 0 jobs' : 'Show options with 0 jobs';
    setAgencyFiltersDisplay();
}

function deptSearchKeyup(evt: Event) {
    const searchInput = <HTMLInputElement>(evt.target);
    foundDepartments = [];
    document.querySelector<HTMLUListElement>('#filter-dept-list')?.querySelectorAll('li').forEach(li => {
        const dept = li.id.substring(li.id.lastIndexOf('-') + 1);
        const deptInput = document.querySelector<HTMLInputElement>(`#department-id-${dept}`);
        if (deptInput === null) {
            return;
        }
        if (searchInput.value.length < 3) {
            document.querySelector<HTMLButtonElement>('#filter-dept-showall-toggle')?.classList.remove('md:hidden');
        }
        else {
            const found = departments[dept]?.Name.toLowerCase().includes(searchInput.value.toLowerCase());
            if (found === true) {
                foundDepartments.push(li);
            }
        }        
    });
    setDepartmentFiltersDisplay();
}

function agencySearchKeyup(evt: Event) {
    const searchInput = <HTMLInputElement>(evt.target);
    foundAgencies = [];
    document.querySelector<HTMLUListElement>('#filter-agency-list')?.querySelectorAll('li').forEach(li => {
        const agency = li.id.substring(li.id.lastIndexOf('-') + 1);
        const agencyInput = document.querySelector<HTMLInputElement>(`#agency-id-${agency}`);
        if (agencyInput === null) {
            return;
        }
        if (searchInput.value.length < 3) {
            document.querySelector<HTMLButtonElement>('#filter-agency-showall-toggle')?.classList.remove('md:hidden');
        }
        else {
            const found = agencies[agency]?.Name.toLowerCase().includes(searchInput.value.toLowerCase());
            if (found === true) {
                foundAgencies.push(li);
            }
        }
    });
    setAgencyFiltersDisplay();
}
